import { Injectable } from '@angular/core';
import { Toast } from '../models/toast';
import { ToastSeverity } from '../types/toast-severity';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';
import { ToastMessageOptions } from 'primeng/api';

type Severity = 'success' | 'warn' | 'error' | 'info';

@Injectable({
  providedIn: 'root',
})
export class ToastToPrimengMessageConverter {
  public convert(toast: Toast): ToastMessageOptions {
    return {
      detail: toast.message,
      summary: toast.title,
      severity: this.severity(toast.severity),
      sticky: toast.immortal,
      life: toast.life,
    };
  }

  private severity(severity: ToastSeverity): Severity {
    const entries = new Map<ToastSeverity, Severity>([
      ['success', 'success'],
      ['info', 'info'],
      ['warning', 'warn'],
      ['error', 'error'],
    ]);

    const entry = entries.get(severity);

    if (isNil(entry)) {
      throw new EntryNotFoundException(
        `The severity entry for "${severity}" not found.`,
      );
    }

    return entry;
  }
}
